/* Accessible expand/collapse labels and resize-safe overflow detection. */
(() => {
  'use strict';
  if (window.bvjProductDescriptions) { window.bvjProductDescriptions(); return; }
  function init() {
    document.querySelectorAll('[data-product-description]').forEach((wrap, index) => {
      if (wrap.dataset.bvjDescriptionReady) return;
      const toggle = wrap.querySelector('.product-description__toggle');
      const content = wrap.querySelector('.product-description__body-content');
      if (!toggle || !content) return;
      wrap.dataset.bvjDescriptionReady = 'true';
      const label = document.createElement('span');
      const collapsed = [...toggle.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim() || 'Toon meer';
      [...toggle.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
      toggle.prepend(label);
      label.textContent = collapsed;
      if (!content.id) content.id = `BvjDescription-${wrap.closest('.shopify-section')?.id || 'product'}-${index}`;
      toggle.setAttribute('aria-controls', content.id);
      const initialLimit = parseFloat(getComputedStyle(content).maxHeight);
      let frame;
      const update = () => {
        const open = wrap.classList.contains('is-open');
        const limit = open ? initialLimit : parseFloat(getComputedStyle(content).maxHeight);
        const exceeds = Number.isFinite(limit) && content.scrollHeight > limit + 2;
        toggle.hidden = !exceeds;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? (toggle.dataset.collapseLabel || 'Toon minder') : collapsed;
      };
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
      toggle.addEventListener('click', () => { wrap.classList.toggle('is-open'); update(); });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        observer.observe(content);
        const cleanup = (event) => {
          if (event.target.contains(wrap)) { observer.disconnect(); cancelAnimationFrame(frame); document.removeEventListener('shopify:section:unload', cleanup); }
        };
        document.addEventListener('shopify:section:unload', cleanup);
      }
      document.fonts?.ready.then(schedule);
      content.addEventListener('load', schedule, true);
      update();
    });
  }
  window.bvjProductDescriptions = init;
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
